var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowPhoneImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#FDB022"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1493_1909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2876 17.75C22.0201 17.8929 22.6934 18.2512 23.2211 18.779C23.7489 19.3067 24.1071 19.9799 24.2501 20.7125M21.2876 14.75C22.8095 14.9191 24.2288 15.6006 25.3123 16.6828C26.3957 17.7649 27.0791 19.1833 27.2501 20.705M26.5001 26.69V28.94C26.5009 29.1489 26.4581 29.3556 26.3745 29.547C26.2908 29.7384 26.168 29.9102 26.0141 30.0514C25.8602 30.1926 25.6785 30.3001 25.4806 30.367C25.2828 30.4339 25.0731 30.4588 24.8651 30.44C22.5572 30.1892 20.3403 29.4006 18.3926 28.1375C16.5804 26.986 15.0441 25.4496 13.8926 23.6375C12.6251 21.6809 11.8363 19.4532 11.5901 17.135C11.5713 16.9276 11.596 16.7186 11.6624 16.5212C11.7289 16.3239 11.8358 16.1425 11.9761 15.9887C12.1165 15.8349 12.2874 15.712 12.4779 15.6279C12.6684 15.5438 12.8743 15.5002 13.0826 15.5H15.3326C15.6966 15.4964 16.0494 15.6253 16.3254 15.8626C16.6014 16.1 16.7816 16.4296 16.8326 16.79C16.9275 17.51 17.1037 18.217 17.3576 18.8975C17.4585 19.1659 17.4803 19.4577 17.4205 19.7382C17.3607 20.0186 17.2217 20.2761 17.0201 20.48L16.0676 21.4325C17.1352 23.3102 18.6899 24.8648 20.5676 25.9325L21.5201 24.98C21.724 24.7784 21.9814 24.6394 22.2619 24.5796C22.5424 24.5198 22.8341 24.5416 23.1026 24.6425C23.783 24.8964 24.49 25.0725 25.2101 25.1675C25.5744 25.2189 25.9071 25.4024 26.145 25.6831C26.3828 25.9638 26.5092 26.3222 26.5001 26.69Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1493_1909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(10 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowPhoneImage);
export default __webpack_public_path__ + "static/media/yellow-phone-image.ab9184886a333bcf8f9fed37d4a54895.svg";
export { ForwardRef as ReactComponent };